module.exports = __webpack_public_path__ + "static/media/package_design_logo_plain.4e1e99a4.svg";